import { Fragment } from 'react'

import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'
import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import { getLas30DaysTransactions, getTransactionsMetrics } from './helpers'
import * as Styles from './styles'

const TransactionsMetrics = ({ metrics, subscriptionPlan, onClickInStats }) => {
  const { hasPermission } = useUserPermissions()
  const transactionsMetrics = getTransactionsMetrics({ metrics, subscriptionPlan, onClickInStats })
  const lasts30DaysTransactions = getLas30DaysTransactions({ metrics, subscriptionPlan, onClickInStats })

  if (!hasPermission(userPermissions.viewTransactionsDefaultViews)) return null

  return (
    <Styles.MainContainer>
      <StatisticGroup>
        {transactionsMetrics.map((transactionMetric, index) => (
          <Fragment key={index}>{transactionMetric.Component}</Fragment>
        ))}
      </StatisticGroup>
      <StatisticGroup>
        {lasts30DaysTransactions.map((transactionMetric, index) => (
          <Fragment key={index}>{transactionMetric.Component}</Fragment>
        ))}
      </StatisticGroup>
    </Styles.MainContainer>
  )
}

export default TransactionsMetrics
